<template>
	<div class="BaseScheduleOrderTable">
		<!-- <div class="table-sns">
      <h3>
        Upload Stock Count
      </h3>
      <a
        class="cursor-pointer"
      >
        Export Count
      </a>
    </div> -->
		<simplebar class="simplebar">
			<table class="tableMain">
				<thead>
					<tr>
						<th colspan="1" class="border-right" style="text-align:center">
							Day
						</th>
						<th colspan="1" class="border-right" style="text-align:center">
							Until
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(schedule, index) in scheduleOrder" :key="index">
						<td>
							<el-select
								v-model="schedule.day"
								style="width: 100%;"
								placeholder="Select Day"
							>
								<el-option
									label="Monday"
									:value="1"
									:disabled="disabledDaysList.indexOf(1) > -1 ? true : false"
								/>
								<el-option
									label="Tuesday"
									:value="2"
									:disabled="disabledDaysList.indexOf(2) > -1 ? true : false"
								/>
								<el-option
									label="Wednesday"
									:value="3"
									:disabled="disabledDaysList.indexOf(3) > -1 ? true : false"
								/>
								<el-option
									label="Thursday"
									:value="4"
									:disabled="disabledDaysList.indexOf(4) > -1 ? true : false"
								/>
								<el-option
									label="Friday"
									:value="5"
									:disabled="disabledDaysList.indexOf(5) > -1 ? true : false"
								/>
								<el-option
									label="Saturday"
									:value="6"
									:disabled="disabledDaysList.indexOf(6) > -1 ? true : false"
								/>
								<el-option
									label="Sunday"
									:value="7"
									:disabled="disabledDaysList.indexOf(7) > -1 ? true : false"
								/>
							</el-select>
						</td>
						<td>
							<el-time-picker
								v-model="schedule.untill"
								placeholder="Select time"
								style="width: 100%"
								value-format="HH:mm:ss"
								format="HH:mm:ss"
							>
							</el-time-picker>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<div class="">
			<!-- <div class=" flex justify-between items-center p-2 pr-4"> -->
			<el-row :gutter="20">
				<el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
					<div>
						<BaseButton
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-xs"
							@click="scheduleOrder.push(addToScheduleOrder())"
						>
							Add More Days
						</BaseButton>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
					<slot name="saveButton"> </slot>
				</el-col>
				<!-- <el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24">
					<div class="md:text-right text-left mt-4">
						<el-pagination
							background
							:page-sizes="[5, 10, 15]"
							layout="sizes, prev, pager, next"
						/>
					</div>
				</el-col> -->
			</el-row>

			<!-- <div class="flex ml-auto items-center"> -->
			<!-- <BaseButton
            class="mr-8"
            buttonclass="btn py-1.5 px-4 text-sm"
          >
            Save
          </BaseButton> -->

			<!-- </div> -->
			<!-- </div> -->
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
export default {
	name: "BaseScheduleOrderTable",
	components: {
		simplebar
	},
	inject: ["$validator"],
	props: {
		scheduleOrder: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {};
	},
	computed: {
		disabledDaysList() {
			return this.scheduleOrder.map(order => order.day);
		}
	},
	created() {
		if (!this.scheduleOrder.length) {
			for (let i = 0; i < 2; i++) {
				this.scheduleOrder.push(this.addToScheduleOrder());
			}
		}
	},
	updated() {
		if (!this.scheduleOrder.length) {
			for (let i = 0; i < 2; i++) {
				this.scheduleOrder.push(this.addToScheduleOrder());
			}
		}
	},
	methods: {
		addToScheduleOrder() {
			return {
				day: "",
				untill: ""
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseScheduleOrderTable.scss";
</style>

<style lang="scss">
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
</style>
